export default __webpack_public_path__ + "75c2e1275bfce34afc6614476a94fb2c.png";